/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <div class="modal">
    <div class="mask"></div>
    <div class="contenido-modal">
      <div v-if="tituloHeader" class="modal-header">
        <div class="titulo-header">{{ tituloHeader }}</div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalBase",
  props: {
    tituloHeader: {
      type: String,
      default: "",
    },
  },
  emits: ["cerrar"],
  methods: {
    closeModal() {
      this.$emit("cerrar");
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  z-index: 2000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  display: flex;
  align-items: center; 
  justify-content: center; 
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mask {
  background-color: transparent;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.contenido-modal {
  user-select: none;
  position: relative;
  background-color: #ffffff;
  margin: auto;
  width: 95%; 
  max-width: 650px; 
  min-width: auto;
  box-shadow: 0px 3px 6px #00000029;
  z-index: 100;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  -webkit-animation: animatetop 0.4s;
  animation: animatetop 0.4s;
}

.modal-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.1);
}

.titulo-header {
  font-size: 22px;
  color: #707070;
  font-weight: bold;
}

@-webkit-keyframes animatetop {
  from { top: -100px; opacity: 0; }
  to { top: 0; opacity: 1; }
}

@keyframes animatetop {
  from { top: -100px; opacity: 0; }
  to { top: 0; opacity: 1; }
}

@media (max-width: 767px) {
  .modal {
    padding: 10px; 
  }

  .contenido-modal {
    width: 100%;
    height: auto; 
    max-height: 95vh; 
    border-radius: 16px;
    overflow-y: auto;
  }

  .cerrar-header {
    height: 60px;
    background: #c49e29;
    margin-bottom: 20px;
  }

  .btn-close {
    margin-right: 15px;
  }
}

.icon-tachita-negra {
  color: #bababa;
  cursor: pointer;
}

.contenedor-titular {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 17px;
}
</style>